// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3u7FF","left":"styles_left__30qZL","desktopActions":"styles_desktopActions__3Y9Jx","title":"styles_title__1g0E_"};